let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4oz7i")).then(() => parcelRequire('itNEA'));